// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__3ZZdX","btn_diamond":"Abutton_btn_diamond__1L39i","btn_bagcolor":"Abutton_btn_bagcolor__32i22"};